import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

/**
 * Light, bordered tooltip used across the app for rich (multi-line / element)
 * content. Mirrors the MUI "HtmlTooltip" recipe.
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    '&::before': {
      backgroundColor: theme.palette.grey[100],
      border: `1px solid ${theme.palette.grey[400]}`,
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.primary,
    maxWidth: 260,
    fontSize: theme.typography.pxToRem(12),
    border: `1px solid ${theme.palette.grey[400]}`,
    padding: '8px 12px',
  },
}));

export default HtmlTooltip;
